import { Banknote, PiggyBank, AlertCircle, FileText } from "lucide-react";

const fmtEur = (n) =>
  new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(Number(n || 0));

export default function ReportSummary({ analysis, input }) {
  const monthlyAmount = input?.monthly_amount || 0;
  const yearlyEstimate = analysis?.estimated_yearly_cost || monthlyAmount * 12;
  const possibleSavings = analysis?.possible_savings || 0;
  const overpaymentRisk = analysis?.overpayment_risk || "Gemiddeld";

  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 fade-up fade-up-delay-1" data-testid="report-summary">
      <Card
        icon={Banknote}
        iconBg="bg-slate-100"
        iconColor="text-slate-700"
        label="Termijnbedrag per maand"
        value={fmtEur(monthlyAmount)}
        sublabel="Wat je nu betaalt"
        testid="summary-monthly"
      />
      <Card
        icon={FileText}
        iconBg="bg-blue-50"
        iconColor="text-blue-700"
        label="Geschatte jaarlijkse kosten"
        value={fmtEur(yearlyEstimate)}
        sublabel="Op basis van contract + termijn"
        testid="summary-yearly"
      />
      <Card
        icon={PiggyBank}
        iconBg="bg-emerald-50"
        iconColor="text-emerald-700"
        label="Mogelijke besparing per jaar"
        value={fmtEur(possibleSavings)}
        sublabel={possibleSavings > 0 ? "Bij overstap naar beter contract" : "Geen significante besparing"}
        highlight={possibleSavings > 0}
        testid="summary-savings"
      />
      <Card
        icon={AlertCircle}
        iconBg={
          overpaymentRisk === "Hoog"
            ? "bg-red-50"
            : overpaymentRisk === "Gemiddeld"
            ? "bg-amber-50"
            : "bg-emerald-50"
        }
        iconColor={
          overpaymentRisk === "Hoog"
            ? "text-red-600"
            : overpaymentRisk === "Gemiddeld"
            ? "text-amber-600"
            : "text-emerald-600"
        }
        label="Overbetaling risico"
        value={overpaymentRisk}
        sublabel="Kans dat je te veel betaalt"
        testid="summary-overpayment"
      />
    </div>
  );
}

function Card({ icon: Icon, iconBg, iconColor, label, value, sublabel, highlight = false, testid }) {
  return (
    <div
      className={`rounded-2xl p-5 sm:p-6 border transition-all ${
        highlight
          ? "bg-gradient-to-br from-emerald-50 to-white border-emerald-200 shadow-[0_8px_30px_-12px_rgba(5,150,105,0.25)]"
          : "bg-white border-slate-200 hover:border-blue-200"
      }`}
      data-testid={testid}
    >
      <div className={`h-10 w-10 rounded-xl ${iconBg} grid place-items-center mb-4`}>
        <Icon className={`h-5 w-5 ${iconColor}`} />
      </div>
      <div className="text-xs font-medium uppercase tracking-wider text-slate-500">{label}</div>
      <div className={`mt-1.5 font-heading font-bold text-2xl ${highlight ? "text-emerald-700" : "text-slate-900"}`}>
        {value}
      </div>
      <div className="mt-1 text-xs text-slate-500">{sublabel}</div>
    </div>
  );
}
